<template>
  <div class="success_container">
    <div class="content">
        <img :src="require('@/assets/img/ok.png')" alt="">
        <p>提交成功</p>
    </div>
  </div>
</template>

<script>
  export default {
    
  }
</script>

<style scoped lang="less">
.success_container {
  width: 100%;
  min-height: 100vh;
  .content {
    width: 100%;
    height: 600px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    display: flex;
    flex-direction: column;
    align-items: center;
    img {
      width: 256px;
      height: 256px;
    }
    p {
      color: red;
      font-size: 40px;
    }
  }
}
</style>